import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const BottomNav = () => {
    const { t } = useTranslation();

    const [showNavBar, setShowNavBar] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
  
    const handleScroll = () => {
      if (window.scrollY < lastScrollY) {
        // scrolling up
        setShowNavBar(true);
      } else {
        // scrolling down
        setShowNavBar(false);
      }
      setLastScrollY(window.scrollY);
    };
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [lastScrollY]);
  
    return (
      <nav className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-in-out ${showNavBar ? 'opacity-100' : 'opacity-0'}`}>
        <div className="px-6 py-3 rounded-full border-2 shadow-lg backdrop-blur-sm bg-background border-border-secondary">
          <ul className="flex items-center space-x-6 text-primary">
            <li>
              <a href="#about" className="transition-colors hover:text-secondary">
                {t("about")}
              </a>
            </li>
            <li>
              <a href="#technologies" className="transition-colors hover:text-secondary">
                {t("technologies")}
              </a>
            </li>
            <li>
              <a href="#projects" className="transition-colors hover:text-secondary">
                {t("projects")}
              </a>
            </li>
            <li>
              <a href="#resume" className="transition-colors hover:text-secondary">
                {t("resume")}
              </a>
            </li>
            <li>
              <a href="#contact" className="transition-colors hover:text-secondary">
                {t("contact")}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
};

export default BottomNav;